var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeadVue'),_c('iframe',{staticStyle:{"width":"100%","height":"calc(100vh - 300px)"},attrs:{"src":"http://60.172.131.22:5700"}}),_c('FooterVue',{staticStyle:{"margin-top":"0"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }